<template>
  <div class="relative">
    <RenderHtml :html="entry.embedData.html" />
    <!-- <pre
      v-if="!entry.embedData || entry.embedData.html === null"
      class="whitespace-pre-wrap text-xs border-red-500 border"
      v-text="entry"
    /> -->
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import RenderHtml from '@/modules/common/components/RenderHtml.vue';
import ArticleCardEmbed from './ArticleCardEmbed.vue';

export default defineComponent({
  components: {
    ArticleCardEmbed,
    RenderHtml,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
});
</script>
<style lang="scss">
.entry--html {
  width: 100%;
  overflow-x: auto;
}
#tpuan {
  font-size: 12px;
  background-color: transparent;
  border-spacing: 0;
  thead {
    background: var(--black);
    color: var(--white);
  }
  tr,
  td,
  th {
    margin: 0px;
    border-collapse: collapse;
    border: 1px solid var(--border-divider-100);
  }
  td {
    padding: 2px;
    vertical-align: middle;
    text-align: center;
  }
  tr:nth-child(even) {
    background-color: #f2f2f2;
  }
}
</style>
